import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiClient } from "@/lib/api";
import { toast } from "sonner";

const ChangePassword = () => {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) return toast.error("New password must be at least 8 characters");
    if (next !== confirm) return toast.error("Passwords don't match");
    setLoading(true);
    try {
      await apiClient.post("/auth/change-password", { current_password: cur, new_password: next });
      refreshUser({ must_change_password: false });
      toast.success("Password updated");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--color-bg)" }}>
      <form
        onSubmit={submit}
        data-testid="change-password-form"
        className="w-full max-w-sm bg-white rounded-lg p-8 shadow-sm"
        style={{ border: "1px solid var(--color-border)" }}
      >
        <h2 className="text-xl font-bold text-[#0F2044] mb-1">Set a new password</h2>
        <p className="text-sm text-gray-500 mb-6">
          Welcome {user?.username}. Please update your password to continue.
        </p>

        {["Current password", "New password", "Confirm new password"].map((label, i) => {
          const setters = [setCur, setNext, setConfirm];
          const values = [cur, next, confirm];
          const testIds = ["cp-current", "cp-new", "cp-confirm"];
          return (
            <div key={label} className="mb-4">
              <label className="block text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1">
                {label}
              </label>
              <input
                data-testid={testIds[i]}
                type="password"
                value={values[i]}
                onChange={(e) => setters[i](e.target.value)}
                className="w-full px-3 py-2 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#0F2044]/30"
                style={{ border: "1px solid var(--color-border)" }}
                required
              />
            </div>
          );
        })}

        <button
          data-testid="cp-submit"
          type="submit"
          disabled={loading}
          className="w-full mt-2 bg-[#0F2044] text-white py-2.5 rounded-md text-sm font-semibold hover:bg-[#1a2f5c] transition-colors disabled:opacity-60"
        >
          {loading ? "Saving..." : "Update password"}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
